import { useEffect } from "react";
import { business } from "@/config/business";

/**
 * StructuredData — JSON-LD LocalBusiness (SEO).
 * Hanya data faktual yang disediakan bisnis — tidak ada klaim palsu.
 */
export const StructuredData = () => {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "HVACBusiness",
      name: business.companyName,
      alternateName: business.brand.name,
      brand: {
        "@type": "Brand",
        name: business.brand.name,
      },
      description: business.description,
      areaServed: `${business.city}, ${business.region}, ${business.country}`,
      address: {
        "@type": "PostalAddress",
        streetAddress: business.address,
        addressLocality: business.city,
        addressRegion: business.region,
        addressCountry: "ID",
      },
      email: business.email,
      telephone: `+${business.whatsapp.international}`,
      url: business.seo.siteUrl,
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "ld-localbusiness";
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById("ld-localbusiness");
      if (el) el.remove();
    };
  }, []);

  return null;
};

export default StructuredData;
